import React, {Component} from 'react';
import LogoTwo from "../../static/img/logo2.png";
import Logo from "../../static/img/logo.png";
import {NavLink} from "react-router-dom";
import {navsList} from "../../config/configPublic"
import "./Navs.scss"

class Navs extends Component {
    render() {
        let {fullPageIndex} = this.props;
        return (
            <div
                className={`home-nav ${fullPageIndex === 1 || fullPageIndex === 3 ? "home-about" : ""} ${fullPageIndex === 2 || fullPageIndex === 4 ? "home-information" : ""} ${fullPageIndex === 5 ? "home-footer" : ""} ${fullPageIndex === 6 ? "home-white" : ""}`}>
                <div className="home-content">
                    <NavLink to="/home" className="home-logo">
                        <img src={fullPageIndex === 2 || fullPageIndex === 4 ? LogoTwo : Logo} alt=""/>
                    </NavLink>
                    <div className="home-list">
                        {
                            navsList.map(((item, index) => {
                                return (
                                    <NavLink key={index}
                                             to={item.pathUrl}
                                             className="item"
                                             activeStyle={{color: "#C31515"}}>
                                        {item.pathname}
                                    </NavLink>
                                )
                            }))
                        }
                    </div>
                    {/*<div className="home-btn">*/}
                    {/*    登录*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}

export default Navs;
